import { Component } from "react";
import { SupportApiManager } from "../supportApiManager";
import keycloak from "../../util/keycloak";
import { Button, Col, Container, FormControl, FormLabel, InputGroup, ListGroup, ListGroupItem, Row, Stack } from "react-bootstrap";
import { SchoolList } from "../components/schoolList";
import { AdminList } from "../components/adminList";

export class SupportDashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            districts: [],
            createDistrictMode: false,
            adminListVersion: 0,
        }
        this.apiManager = new SupportApiManager()
    }

    async refreshDistrictList() {
        const districts = await this.apiManager.getDistricts()
        this.setState({districts})
    }

    async componentDidMount() {
        if (!this.apiManager.hasValidAuthToken()) {
            keycloak.login()
            return
        }
        await this.refreshDistrictList()
    }

    setFocusedDistrict = async (district) => {
        this.setState({
            focusedDistrict: district,
            createDistrictMode: false,
        })
    }

    createDistrictMode = () => {
        this.setState({
            createDistrictMode: true,
            focusedDistrict: {
                districtCode: '',
                districtName: '',
            },
        })
    }

    updateDistrictValue = field => (e) => {
        this.setState({
            focusedDistrict: {
                ...this.state.focusedDistrict,
                [field]: e.target.value,
            }
        })

    }

    cancelCreate = () => {
        this.setState({
            focusedDistrict: undefined,
            createDistrictMode: false,
        })
    }

    createNewDistrict = async () => {
        if (!this.validateDistrictInfo()) {
            return
        }
        const districtInfo = {
            districtName: this.state.focusedDistrict.districtName,
            districtCode: this.state.focusedDistrict.districtCode,
        }
        const result = await this.apiManager.createDistrict(districtInfo)
        if (!result) {
            return
        }
        alert(`New district, ${this.state.focusedDistrict.districtName}, created`)
        this.cancelCreate()
        this.refreshDistrictList()
    }

    validateDistrictInfo() {
        const districtCodeRegex = /^[a-z][a-z0-9-]{2,24}$/
        if (!this.state.focusedDistrict.districtName) {
            alert('District info cannot be empty')
            return false
        }
        if (this.state.districts.some(district =>
            district.districtCode === this.state.focusedDistrict.districtCode
            || district.districtName === this.state.focusedDistrict.districtName)
        ) {
            alert('District info cannot be the same as an existing district')
            return false
        }
        if (!this.state.focusedDistrict.districtCode || !districtCodeRegex.test(this.state.focusedDistrict.districtCode)) {
            alert('District code must be lowercase alphanumeric between 3 and 25 character. Must also start with a letter.')
            return false
        }
        return true
    }

    updateAdminListVersion = () => {
        this.setState({
            adminListVersion: this.state.adminListVersion + 1,
        })
    }

    render() {
        return (
            <Container fluid className="p-4">
                <Row>
                    <Col className="px-4" xs={12} lg={6}>
                        <Stack className="justify-content-between" direction="horizontal">
                            <h3 className="mt-3">Districts</h3>
                            {!this.state.createDistrictMode && <Button onClick={() => this.createDistrictMode()}>Create District</Button>}
                        </Stack>
                        <ListGroup className="my-3">
                            {this.state.districts.map(((item, idx) => 
                                <ListGroupItem action key={idx} onClick={() => this.setFocusedDistrict(item)} active={!this.state.createDistrictMode && this.state.focusedDistrict?.districtCode === item.districtCode}>
                                    <Stack className="justify-content-between" direction="horizontal">
                                        <span>{item.districtName} <span>{`(${item.districtCode})`}</span></span>
                                        {this.state.focusedDistrict?.districtCode === item.districtCode && !this.state.createDistrictMode
                                            ? <i class="bi bi-caret-right-fill"></i>
                                            : <i class="bi bi-caret-right"></i>
                                        }
                                    </Stack>
                                    
                                </ListGroupItem>
                            ))}
                            {(this.state.districts.length < 1) &&
                                <ListGroupItem>No districts associated with Teach Insights</ListGroupItem>
                            }
                        </ListGroup>
                    </Col>
                    {this.state.focusedDistrict &&
                        <Col className="px-4" xs={12} lg={6}>
                            <h3>District Info</h3>
                            <Container>
                                <FormLabel htmlFor="district-name">Name</FormLabel>
                                <InputGroup>
                                    <FormControl
                                        id="district-name"
                                        readOnly={!this.state.createDistrictMode}
                                        disabled={!this.state.createDistrictMode}
                                        value={this.state.focusedDistrict.districtName}
                                        onChange={this.updateDistrictValue('districtName')}
                                    />
                                </InputGroup>
                                <FormLabel className="mt-2" htmlFor="district-code">Code</FormLabel>
                                <InputGroup>
                                    <FormControl
                                        id="district-code"
                                        readOnly={!this.state.createDistrictMode}
                                        disabled={!this.state.createDistrictMode}
                                        value={this.state.focusedDistrict.districtCode}
                                        onChange={this.updateDistrictValue('districtCode')}
                                    />
                                </InputGroup>
                            </Container>
                            {!this.state.createDistrictMode && <SchoolList districtCode={this.state.focusedDistrict.districtCode} updateAdminList={this.updateAdminListVersion} />}
                            {!this.state.createDistrictMode && <AdminList districtCode={this.state.focusedDistrict.districtCode} version={this.state.adminListVersion} />}
                            {this.state.createDistrictMode && <Stack className="m-2" direction="horizontal">
                                <Button className="me-3" onClick={() => this.createNewDistrict()}>Create</Button>
                                <Button variant="danger" onClick={() => this.cancelCreate()}>Cancel</Button>
                            </Stack>}
                        </Col>
                    }
                </Row>
            </Container>
        )
    }
}
